// extracted by mini-css-extract-plugin
export var image = "product-item-module--image--cf8d8";
export var key = "product-item-module--key--2e523";
export var root = "product-item-module--root--67aaa";
export var row = "product-item-module--row--0aae2";
export var series = "product-item-module--series--28144";
export var specs = "product-item-module--specs--98095";
export var text = "product-item-module--text--b9ad8";
export var title = "product-item-module--title--4c552";
export var titleRow = "product-item-module--titleRow--25917";
export var value = "product-item-module--value--d936d";